module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/dashboard/Employees.ejs -->\n<div class="ibox float-e-margins">\n    <div class="ibox-title">\n        <h5>Employees</h5>\n    </div>\n\n    <div class="js-loader ibox-content loader-container">\n        <div class="loader">\n            '+
((__t=( require('commons/templates/Spinner.html')() ))==null?'':__t)+
'\n        </div>\n    </div>\n\n    <div class="js-employees-content"></div>\n\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/dashboard/Employees.ejs
// module id = 1018
// module chunks = 1